import { REQUIRED_TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { object, ObjectSchema } from 'yup';

interface EditDepositAccountValidationSchemaType {
  name: string;
}

export const editDepositAccountValidationSchema: ObjectSchema<EditDepositAccountValidationSchemaType> = object().shape({
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
});
